var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lDfault',{attrs:{"title":_vm.loginText+'登陆'}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.loginHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }